export default __webpack_public_path__ + "static/media/CL02.becf9f64.mp3";